import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { AddressInput, ButtonMain, InputMain } from 'components';
import { ReportTypeEnum } from 'fragments';
import { HomeBanner, HowWeHelp, BothReports, SimpleSteps, WorkWithUs } from './fragments';
import { Svg } from 'assets';
import { useWindowSize } from 'utils';

export const Home = ({ handleChangeFrvOrFmv }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [width] = useWindowSize();
  const info = location?.state;
  const isFRV = info?.reportType === ReportTypeEnum.FRV;

  const {
    handleSubmit,
    control,
    setValue,
  } = useForm({
    defaultValues: {
      address: '',
      email: '',
    },
  });

  useEffect(() => {
    if (location?.hash) {
      const element = document.getElementById(location?.hash?.slice(1));
      if (element) {
        element.scrollIntoView({ block: 'end', behavior: 'smooth' });
      }
    }

  }, [location]);


  const onSubmit = (data) => {
    const params = {
      ...info,
    };
    data?.address ? params.address = data?.address : delete params.address;
    data?.email ? params.email = data?.email : delete params.email;
    navigate('/order-now', { state: params });
  };

  return (
    <div className='home-page'>
      <HomeBanner
        handleSubmit={handleSubmit}
        control={control}
        setValue={setValue}
        onSubmit={onSubmit}
        reportType={info?.reportType}
        isFRV={isFRV}
        handleChangeFrvOrFmv={handleChangeFrvOrFmv}
      />
      {width <= 1279 &&
        <form className='address-email-radio-wrapper' onSubmit={handleSubmit(onSubmit)}>
          <RadioGroup
            aria-labelledby='demo-radio-buttons-group-label'
            className={'address-email-radio-buttons-group'}
            defaultValue={ReportTypeEnum.FRV}
            name='radio-buttons-group'
            onChange={(e) => handleChangeFrvOrFmv(e.target.value)}
          >
            <FormControlLabel
              value={ReportTypeEnum.FRV}
              className={isFRV ? 'address-email-radio-buttons-form-active radio-buttons-frv-active' : 'address-email-radio-buttons-form'}
              control={
                <Radio
                  sx={{
                    color: '#D0D5DD',
                    '&.Mui-checked': {
                      color: '#0C66E4',
                    },
                  }}
                />
              }
              label={width < 769 ? 'FRV Report' : 'Fair Rental Value Report'}
            />
            <FormControlLabel
              value={ReportTypeEnum.FMV}
              className={!isFRV ? 'address-email-radio-buttons-form-active radio-buttons-fmv-active' : 'address-email-radio-buttons-form'}
              control={
                <Radio
                  sx={{
                    color: '#D0D5DD',
                    '&.Mui-checked': {
                      color: '#0C66E4',
                    },
                  }}
                />}
              label={width < 769 ? 'FMV Report' : 'Fair Market Value Report'}
            />
          </RadioGroup>

          <div className='address-email-button'>
            <AddressInput
              className='banner-input banner-address'
              control={control}
              name='address'
              placeholder='Enter Property Address'
              customDesign={false}
              allowError={false}
              setValue={setValue}
            />

            <InputMain
              className='banner-input banner-email'
              control={control}
              name='email'
              placeholder='Enter Your Email'
              customDesign={false}
              allowError={false}
            />

            <ButtonMain
              type='submit'
              startAdornment={<Svg.Listing />}
              text={width > 1279 ? `Get Your ${info?.reportType} Report Now` : `${info?.reportType} Report`}
              className='report-button'
            />
          </div>
        </form>
      }


      <HowWeHelp />

      <WorkWithUs />

      <SimpleSteps />

      <BothReports />
    </div>
  );
};

